import { BellPlus } from "lucide-react";
import { EmptyState as SharedEmptyState } from "@tribunalea/ui";

export function EmptyState({ onCreate }) {
  return (
    <SharedEmptyState
      icon={BellPlus}
      title="Todavía no creaste alertas"
      description="Configurá el primer seguimiento y Praxis te avisará cuando haya novedades."
      action={(
        <button className="button primary" onClick={onCreate}>
          Crear primera alerta
        </button>
      )}
    />
  );
}
